import { bundledPack } from './card-pack-bundled.js';
import type { CardPackInfo } from './card-packs.js';

/**
 * The adult-edition-only packs. Kept in their own module and reached only from the `__EDITION__ === 'adult'` branch in
 * card-packs.ts, so a child build tree-shakes them away and carries none of their names or taglines
 * (edition/bundle-exclusion.test.ts guards it, like the adult-only games). The PURE annotations below keep the bundler free to drop these
 * calls from a child build: a plain top-level call counts as a side effect and would keep the names in the bundle.
 */
export const ADULT_ONLY_PACKS: readonly CardPackInfo[] = [
  /* @__PURE__ */ bundledPack({ id: 'undead', name: 'Crypt Court', tagline: 'The Lich King and his silent court.', family: 'fantasy', editions: ['adult'] }),
  /* @__PURE__ */ bundledPack({ id: 'orc', name: 'Iron Tusk Warband', tagline: 'Tusks, banners and a throne of war.', family: 'fantasy', editions: ['adult'] }),
];
